// Shared validation mixin for dog number input fields
// Provides validation logic to validate the number of dogs (max 5)

export const DogNumberValidation = {
  MAX_DOGS: 5,

  // Validate the number input value (does not cap, just validates)
  validateNumberInput(inputElement) {
    const value = parseInt(inputElement.value, 10);

    // If value is greater than max, return true (indicating validation error)
    if (!isNaN(value) && value > this.MAX_DOGS) {
      return true; // Validation error occurred
    }

    return false; // No validation error
  },

  // Check if the input value is valid (not greater than max)
  isValid(inputElement) {
    return !this.validateNumberInput(inputElement);
  },

  getErrorElement(element, errorMessageElementId) {
    return (
      document.getElementById(errorMessageElementId) ||
      element.querySelector(`#${errorMessageElementId}`)
    );
  },

  // Show validation error message
  showError(element, errorMessageElementId) {
    const errorElement = this.getErrorElement(element, errorMessageElementId);
    if (errorElement) {
      errorElement.style.display = 'block';
    }
  },

  // Hide validation error message
  hideError(element, errorMessageElementId) {
    const errorElement = this.getErrorElement(element, errorMessageElementId);
    if (errorElement) {
      errorElement.style.display = 'none';
    }
  },

  // Validate number input and show/hide error message
  validateAndShowError(inputElement, containerElement, errorMessageElementId) {
    const hasError = this.validateNumberInput(inputElement);

    if (hasError) {
      this.showError(containerElement, errorMessageElementId);
    } else {
      this.hideError(containerElement, errorMessageElementId);
    }

    return hasError;
  },
};
